/**
 * Get user's current location using browser Geolocation API
 * Returns a promise that resolves to { latitude, longitude } or rejects with error
 */
export const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by your browser'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => {
        let errorMessage = 'Unable to retrieve your location';
        
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = 'Location permission denied';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = 'Location information unavailable';
            break;
          case error.TIMEOUT:
            errorMessage = 'Location request timed out';
            break;
          default:
            errorMessage = 'An unknown error occurred';
        }
        
        reject(new Error(errorMessage));
      },
      {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 300000, // Cache location for 5 minutes
      }
    );
  });
};

/**
 * Pincode to approximate coordinates mapping (for India)
 * This is a fallback when user doesn't grant location permission
 * In production, you should use a proper geocoding API
 */
const PINCODE_COORDINATES = {
  '500001': { latitude: 17.3850, longitude: 78.4867 }, // Hyderabad
  '500002': { latitude: 17.3753, longitude: 78.4794 },
  '500003': { latitude: 17.4065, longitude: 78.4691 },
  '500004': { latitude: 17.4239, longitude: 78.4738 },
  '110001': { latitude: 28.6448, longitude: 77.2167 }, // Delhi
  '400001': { latitude: 18.9388, longitude: 72.8356 }, // Mumbai
  '560001': { latitude: 12.9716, longitude: 77.5946 }, // Bangalore
  '600001': { latitude: 13.0827, longitude: 80.2707 }, // Chennai
  '700001': { latitude: 22.5726, longitude: 88.3639 }, // Kolkata
};

/**
 * Get coordinates from pincode
 * Returns { latitude, longitude } or null if pincode not found
 */
export const getCoordinatesFromPincode = (pincode) => {
  return PINCODE_COORDINATES[pincode] || null;
};

/**
 * Format distance for display
 */
export const formatDistance = (distanceKm) => {
  if (distanceKm == null) return null;
  if (distanceKm < 1) {
    return `${Math.round(distanceKm * 1000)} m`;
  }
  return `${distanceKm.toFixed(1)} km`;
};

